import React from 'react';
import ResultPageModalButtons from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModalButtons';

function InfortunioModalButtons({
  insuranceRequest,
  processingQuote,
  type,
  riskQuotations,
  removeItemFromCart,
}) {
  let title = type.id === 'res_civile' && insuranceRequest.product.id === 1002
    ? 'Morte da Infortunio'
    : type.name;
  if (insuranceRequest.product.id === 1002 && type.id === 'estensione_nucleo_famigliare') {
    title = `${title ?? type.name} (Massimo 3 componenti)`;
  }

  return (
    <ResultPageModalButtons
      insuranceRequest={insuranceRequest}
      processingQuote={processingQuote}
      type={type}
      riskQuotations={riskQuotations}
      removeItemFromCart={removeItemFromCart}
      title={title}
      selectFirstLabel="Morte da Infortunio"
      excludedCompanyIds={[8]}
    />
  );
}

export default InfortunioModalButtons;
